export const getCategoryTitle = (category: string) => {
  switch (category) {
    case 'MODUL_AJAR':
      return 'Modul Ajar'
    case 'BAHAN_AJAR':
      return 'Bahan Ajar'
    case 'MODUL_PROJEK':
      return 'Modul Projek'
    default:
      return category
  }
}
